import { createSelector } from '@ngrx/store';
import { CacheState, initialCacheState } from '../types/cache.state';
import { selectOfflineFeature } from './pace-offline-feature.selector';

export const selectOfflineCache = createSelector(selectOfflineFeature, (state) => state.cache);

export const getCachedResponseByUrl = createSelector(
    selectOfflineCache,
    (state: CacheState, props: { url: string }) => {
        return state[props.url];
    },
);

export const isCacheEmpty = createSelector(selectOfflineCache, (state: CacheState) => state === initialCacheState);
